import { emptyAPIReceipt } from '@/data';

import type { APIReceipt } from '../types';

export async function fetchReceipt(orderid: string, mailid: string): Promise<APIReceipt> {


  let params;
  let urlParams = '';
  if(orderid !== undefined && orderid !== '' && mailid !== undefined && mailid !== ''){
    params = new URLSearchParams({
      id: orderid,
      mailid: mailid
    });
    urlParams = '?' + params.toString();
  }
  try {
    const response = await fetch('/of2/private_services/receipt'+urlParams, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      }
    });
    const data = await response.json();
    if (data) {
      return data;
    } else {
      throw new Error('Invalid receipt format');
    }
  } catch (e) {
    console.error("Failed to fetch receipt:", e);
    return emptyAPIReceipt; // Fallback empty receipt
  }
}
